// @flow
import React from 'react';

import FormattedDate, { type FormattedDateProps } from './FormattedDate';

/** Basically the same as FormattedDate but with different defaults */
export const FormattedDateTime = (props: FormattedDateProps) => (
    <FormattedDate {...props} className='datetime-component' />
);

FormattedDateTime.defaultProps = {
    format: 'lll',
    helpFormat: 'LLLL',
};

export default FormattedDateTime;
